"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmperorsWeaknessEffectHandler = exports.EmperorsWeaknessEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const MaxAttributeDecrease_1 = require("./MaxAttributeDecrease");
class EmperorsWeaknessEffectArgs {
    constructor(armorDecrease, attributeDecrease) {
        this.armorDecrease = armorDecrease;
        this.attributeDecrease = attributeDecrease;
        this.__type = EffectType_1.EffectType.EmperorsWeakness;
        this.__typeName = "EmperorsWeakness";
        this.name = "Emperor's Weakness";
        this.harmful = true;
    }
}
exports.EmperorsWeaknessEffectArgs = EmperorsWeaknessEffectArgs;
let EmperorsWeaknessEffectHandler = class EmperorsWeaknessEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.children = [
            new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Power, state.args.attributeDecrease),
            new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Focus, state.args.attributeDecrease),
            new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Toughness, state.args.attributeDecrease),
            new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Vitality, state.args.attributeDecrease),
            new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Will, state.args.attributeDecrease),
        ].map(effect => container.applyEffect(sequence, state.creatorId, state.targetId, effect, Duration_1.Duration.Permanent, true));
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        (state.meta.children || []).map(child => container.cancelEffect(sequence, child));
    }
};
EmperorsWeaknessEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.EmperorsWeakness)
], EmperorsWeaknessEffectHandler);
exports.EmperorsWeaknessEffectHandler = EmperorsWeaknessEffectHandler;
